import { render, staticRenderFns } from "./privilegeList.vue?vue&type=template&id=ecfc17c0&scoped=true"
import script from "./privilegeList.vue?vue&type=script&lang=js"
export * from "./privilegeList.vue?vue&type=script&lang=js"
import style0 from "./privilegeList.vue?vue&type=style&index=0&id=ecfc17c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfc17c0",
  null
  
)

export default component.exports